import React from 'react'; 
import Create from './Create';
import HeartlandAuthRedirect from './HeartlandAuthRedirect';

const CreateOrHeartlandAuth = () => {
    console.log('cookies: ', document.cookie); 
    return document.cookie.includes("heartland-access-check") ? <Create /> : <HeartlandAuthRedirect />; 
}; 

export default CreateOrHeartlandAuth; 